import * as React from "react";
import { Polygon } from "@react-google-maps/api";
import type { Zone } from "../../types";

type Props = {
  zone: Zone;
  active: boolean;
  onClick: (z: Zone, e: google.maps.MapMouseEvent) => void;
};

const CityZonePolygon = React.memo(function CityZonePolygon({
  zone,
  active,
  onClick,
}: Props) {
  const paths = React.useMemo(() => zone.polygon, [zone.id]);

  const options = React.useMemo<google.maps.PolygonOptions>(
    () => ({
      fillColor: "#8E8682",
      fillOpacity: active ? 0.7 : 0.5,
      strokeColor: "#8E8682",
      strokeWeight: active ? 4 : 2,
      zIndex: active ? 2 : 1,
      clickable: true,
    }),
    [active, zone.id]
  );

  const handleClick = React.useCallback(
    (e: google.maps.MapMouseEvent) => onClick(zone, e),
    [onClick, zone]
  );

  return <Polygon paths={paths} options={options} onClick={handleClick} />;
});

export default CityZonePolygon;
